import { CategoriesList } from "components/UI/molecules";
import "./index.scss";
import { useGetCategories } from "./utils/useGetCategories";
import { withApolloProvider } from "providers/ApolloClientProvider";
import { GRAPHQL_CMS_BASE_URL } from "constants/endpoints";
import { Skeleton } from "components/UI/atoms";

const TopCategories = () => {
  const { data, loading } = useGetCategories();

  const skeletons = Array(8).fill(<Skeleton height="19px" />);

  return (
    <div className="top-categories">
      {loading && (
        <>
          {skeletons.map((skeleton, index) => (
            <div key={index} style={{ marginBottom: "5px" }}>
              {skeleton}
            </div>
          ))}
        </>
      )}
      {!loading && data && (
        <>
          <h3 className="categories-header">
            {data.getCurrentCategories.title}
          </h3>
          <CategoriesList categories={data.getCurrentCategories.list} />
        </>
      )}
    </div>
  );
};

export default withApolloProvider(TopCategories, {
  graphqlEndpoint: GRAPHQL_CMS_BASE_URL
});
